const SCOPE_LABEL_KEY = {
  IN_SCOPE: 'settings.scope.scopeInScope',
  OUT_OF_SCOPE: 'settings.scope.scopeOutOfScope',
  PENDING: 'settings.scope.scopePending',
} as const;

export function effectiveScopeValue({
  scope,
  effectiveScope,
}: {
  scope?: string | null;
  effectiveScope?: string | null;
}): {
  scope: string | null;
  scopeInherited: boolean;
} {
  if (!scope) {
    return { scope: effectiveScope ?? null, scopeInherited: false };
  }

  if (scope === 'INHERIT') {
    return {
      scope:
        effectiveScope && effectiveScope !== 'INHERIT' ? effectiveScope : null,
      scopeInherited: Boolean(effectiveScope && effectiveScope !== 'INHERIT'),
    };
  }

  return { scope, scopeInherited: false };
}

export function listCountOrEmpty({
  count,
}: {
  count?: number;
}): number | undefined {
  return count !== undefined && count > 0 ? count : undefined;
}

export { SCOPE_LABEL_KEY };
